import "./css/App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ContactsProvider } from "./context/ContactsContext";
import NotFoundPage from "./pages/error/NotFoundPage";
import Footer from "./components/Footer";
import ConsentBanner from "./components/ConsentBanner";
import Home from "./pages/Home";
import About from "./pages/About";
import Prodotti from "./pages/Prodotti";
import Contatti from "./pages/Contatti";
import Agevolazioni from "./pages/Agevolazioni";
import Offerte from "./pages/Offerte";
import Login from "./pages/Login";
import OffertAdmin from "./pages/OffertAdmin";
import AdminSettings from "./pages/AdminSettings";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import TermsOfService from "./pages/TermsOfService";

function App() {
  return (
    <ContactsProvider>
      <Router>
        <Routes>
          {/* AUTHENTICATION ROUTES */}
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/prodotti" element={<Prodotti />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/agevolazioni" element={<Agevolazioni />} />
          <Route path="/offerte" element={<Offerte />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<OffertAdmin />} />
          <Route path="/admin/settings" element={<AdminSettings />} />

          {/* POLICY ROUTES */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />

          {/* ERROR ROUTES */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <ConsentBanner />
        <Footer />
      </Router>
    </ContactsProvider>
  );
}
export default App;